/**
 * Functions
 */
const getNotifications = state => state.reducers.notifications;
export default {
  getNotifications,
};
